import { TranslateFn } from 'hooks/useTranslate';
import { SharesTitle } from 'types';

type GenerateSharesTitlesFilenameProps = {
  sharesTitle: Partial<SharesTitle>;
  t: TranslateFn;
  includeSection?: boolean;
  isEncumbranceTitle?: boolean;
};

type GenerateSharesTitlesFilenameWithCoOwnersProps = {
  sharesTitle: SharesTitle;
  t: TranslateFn;
};

export const generateSharesTitlesFilename = ({
  sharesTitle,
  t,
  includeSection = true,
  isEncumbranceTitle = false,
}: GenerateSharesTitlesFilenameProps): string => {
  const titleLabel = t('Title');

  const baseTitle = isEncumbranceTitle
    ? sharesTitle?.encumbranceNumber
    : sharesTitle?.number;

  const resolvedTitle = baseTitle ? `${titleLabel} #${baseTitle}` : titleLabel;

  if (!includeSection) {
    return resolvedTitle;
  }

  if (!sharesTitle?.numberReplaced) {
    return resolvedTitle;
  }

  return `${resolvedTitle} - ${t('Section')} ${sharesTitle.numberReplaced}`;
};

export const generateSharesTitlesFilenameWithCoOwners = ({
  sharesTitle,
  t,
}: GenerateSharesTitlesFilenameWithCoOwnersProps) => {
  const titleName = generateSharesTitlesFilename({
    sharesTitle,
    t,
    includeSection: false,
    isEncumbranceTitle: true,
  });
  return `${titleName} ${t('withEncumbrances')}`;
};
